import Bluebird from 'bluebird';

if (process.env.NODE_ENV === 'development') {
  Bluebird.config({
    longStackTraces: true,
  });
}

export default function useBluebird() {
  // Override native promises or core-js promise polyfill
  // with Bluebird promises:
  global.Promise = Bluebird;
}
